<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<gh-ext-preloader class="m-preloader" [size]="120" [loading]="isForegroundLoading"></gh-ext-preloader>
<gh-wait [show]="isBackgroundLoading" mode="background"></gh-wait>
<gh-ext-no-data *ngIf="isNoData" [forceIcon]="true" message="{{'lbl_no_entries' | translate}}"></gh-ext-no-data>
